import {PaymentCategoryScope} from "@/api/appService";

const paymentCategoryScopeMapping:any = {
  Project:'项目',
  Reimbursement:'报销单',
  Salary:'工资分摊',
  IncomeRecord:'收入记录',
  PayrollRequisition:'请款单'
}


export {paymentCategoryScopeMapping};
